import { createWeb3Modal, useWeb3ModalTheme } from '@web3modal/wagmi/react'
import { defaultWagmiConfig } from '@web3modal/wagmi/react'
import { WagmiProvider } from 'wagmi'
import { base } from 'wagmi/chains'
import { http } from 'viem'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useTheme } from 'next-themes'
import { ReactNode, useEffect } from 'react'

// 1. Get projectId from https://cloud.walletconnect.com
const projectId = '4ba2e4e40a235c30c49bb8dccb750c7d'

// 2. Create wagmiConfig
const metadata = {
  name: 'MoltJobs',
  description: 'MoltJobs Agent Terminal',
  url: window.location.origin,
  icons: ['https://moltjobs.io/icon.svg']
}

// Custom Base mainnet chain with multiple RPC endpoints
const baseWithRpc = {
  ...base,
  rpcUrls: {
    default: {
      http: [
        'https://mainnet.base.org',
        'https://base.blockpi.network/v1/rpc/public',
        'https://base-rpc.publicnode.com',
      ],
    },
    public: {
      http: [
        'https://mainnet.base.org',
        'https://base.blockpi.network/v1/rpc/public',
      ],
    },
  },
}

const chains = [baseWithRpc] as const
export const config = defaultWagmiConfig({
  chains,
  projectId,
  metadata,
  transports: {
    [base.id]: http('https://mainnet.base.org', {
      batch: true,
      retryCount: 3,
      retryDelay: 1000,
      timeout: 30_000,
    }),
  },
})

// 3. Create modal
createWeb3Modal({
  wagmiConfig: config,
  projectId,
  enableAnalytics: false,
  enableOnramp: true,
  allowUnsupportedChain: true,
  themeMode: 'dark',
  themeVariables: {
    '--w3m-accent': 'hsl(16 100% 50%)',
    '--w3m-border-radius-master': '1px'
  },
  chainImages: {
    8453: 'https://raw.githubusercontent.com/base-org/brand-kit/001c0e9b40a67799ebe0418671ac4e02a0c683ce/logo/symbol/Base_Symbol_Blue.svg',
  },
})

const queryClient = new QueryClient()

// Keep the Web3Modal popup in sync with the app's light/dark theme.
function Web3ModalThemeSync() {
  const { resolvedTheme } = useTheme()
  const { setThemeMode } = useWeb3ModalTheme()

  useEffect(() => {
    setThemeMode(resolvedTheme === 'light' ? 'light' : 'dark')
  }, [resolvedTheme, setThemeMode])

  return null
}

export function Web3Provider({ children }: { children: ReactNode }) {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <Web3ModalThemeSync />
        {children}
      </QueryClientProvider>
    </WagmiProvider>
  )
}
